import { jsx as _jsx } from "react/jsx-runtime";
import { usePatientId } from "@madmedical/user";
import { invariant } from "@madmedical/utils";
import { MeasurementProtocolModalForm, Modal, useShowToast, } from "@madmedical/ui";
import { ApiFormWrapper } from "@madmedical/form";
import { useGetAllProtocolsQuery, useGetThresholdsProtocolsQuery, useUpsertThresholdMutation, } from "./api";
const EditThresholdModal = ({ metricType, open, onClose }) => {
    var _a;
    const { patientId } = usePatientId();
    const { data: protocols, isLoading: isProtocolsLoading } = useGetAllProtocolsQuery({ metricType });
    const { thresholdsProtocol, isLoading: isThresholdsLoading } = useGetThresholdsProtocolsQuery(patientId, {
        selectFromResult: ({ data: thresholdsProtocols, isLoading, isUninitialized, }) => ({
            thresholdsProtocol: thresholdsProtocols === null || thresholdsProtocols === void 0 ? void 0 : thresholdsProtocols.find((thresholdProtocol) => thresholdProtocol.metricType === metricType),
            isLoading: isLoading || isUninitialized,
        }),
    });
    const [upsertThreshold] = useUpsertThresholdMutation();
    const showToast = useShowToast();
    const handleSuccess = () => {
        showToast("Sikeres mentés.", { variant: "success" });
    };
    if (isProtocolsLoading || isThresholdsLoading) {
        return null;
    }
    invariant(protocols);
    if (!thresholdsProtocol) {
        // Nothing to edit
        return null;
    }
    const currentThreshold = thresholdsProtocol.thresholds[0];
    return (_jsx(Modal, Object.assign({ open: open, size: "sm", onClose: onClose }, { children: _jsx(ApiFormWrapper, Object.assign({ defaultValues: {
                patientId,
                threshold: currentThreshold,
                instructions: (_a = thresholdsProtocol.protocol) !== null && _a !== void 0 ? _a : undefined,
            }, mutation: upsertThreshold, onSuccess: handleSuccess }, { children: ({ submitForm, isSuccess }) => (_jsx(MeasurementProtocolModalForm, { metricType: metricType, protocols: protocols.map(({ instructions }) => instructions), onClose: onClose, onSubmitPress: submitForm, isSuccess: isSuccess })) })) })));
};
export default EditThresholdModal;
